/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-bar[_ngcontent-%COMP%]{box-shadow:#0ff}.login[_ngcontent-%COMP%]{flex:1 1 auto}mat-toolbar.primary-menu[_ngcontent-%COMP%]{height:40px}"];
export { styles as styles };
